import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=000cef79&scoped=true"
import script from "./goals.vue?vue&type=script&lang=js"
export * from "./goals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cef79",
  null
  
)

export default component.exports